// extracted by mini-css-extract-plugin
module.exports = {"ServicesNonSlider":"styles_ServicesNonSlider__4MaHH","ServicesGrid":"styles_ServicesGrid__ZUVsW","height":"styles_height__iZlPx"};